import axios from 'axios'
import Utils from '@/common/utils'

const baseUrl = `${process.env.VUE_APP_RISKY_URL}/api-external`
const headers = {
  'Content-Type': 'application/json',
  Authorization: Utils.setRiskyAppToken()
}

export default class RiskInsightsService {
  static async getTaxpayer (rfc) {
    const url = baseUrl + `/taxpayer/${rfc}`
    const { data } = await axios.get(url, { headers })
    return data?.data
  }

  static async getInvoicesBalance (clientId) {
    const url = baseUrl + `/invoice/balance/${clientId}`
    const { data } = await axios.get(url, { headers })
    return data?.data
  }
}
